import { Component, Input, OnDestroy, OnInit } from '@angular/core';

@Component({
	selector: 'error-message-modal',
	template: require('./error-message-modal.html'),
	styles: [require('./error-message-modal.scss')]
})
export class ErrorMessageModalWebComponent implements OnInit, OnDestroy {
	@Input() title: string;
	@Input() errorMessage: string;

	constructor() {}

	ngOnInit() {}

	ngOnDestroy() {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/common/error-message-modal/error-message-modal.ts